export default __webpack_public_path__ + "language-dropdown/DE.png";